<template>
  <div class="ml-1">
    <h4 class="mt-2 mb-2">
      Select Template Group
    </h4>
    <b-form-group
      data-test="template-selector"
      invalid-feedback="Please select a template"
    >
      <b-form-input
        v-if="!canTemplateGroupBeChanged"
        v-model="selectedTemplateGroup.name"
        readonly
      />
      <base-autocomplete
        v-else
        id="creative-template-select"
        v-model="selectedTemplateGroup"
        type="dropdown"
        :items="availableTemplateGroups"
        data-test="creative-template-select"
        @input="clearSelectedTemplates"
        @submit="updateCreativeTemplateGroup($event)"
        @change="updateCreativeTemplateGroup(selectedTemplateGroup)"
      />
    </b-form-group>
    <div v-if="!isModalView">
      <template-group-templates
        ref="template-group-templates"
        :selected-group-id="selectedGroupId"
        :template-list="templateList"
        :disabled="!canTemplateGroupBeChanged"
        @updateTemplatesSelected="updateTemplates"
      />
    </div>
  </div>
</template>
<script>
import {
  mapState, mapActions, mapGetters, mapMutations,
} from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as templatesTypes from '@/modules/templates/store/types';
import BaseAutocomplete from '@/components/form/BaseAutocomplete';
import TemplateGroupTemplates from '@/modules/content/components/CreativesPage/Sidebar/CreativeType/TemplateGroupTemplates';

function initialData() {
  return {
    availableTemplateGroups: [],
    selectedTemplateGroup: {},
    selectedGroupId: null,
    templateList: [],
  };
}

export default {
  name: 'TemplateGroup',
  components: {
    TemplateGroupTemplates,
    BaseAutocomplete,
  },
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return initialData();
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'activeCreatives',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_CAMPAIGN_READONLY,
    ]),
    activeTemplateIds() {
      if (!this.activeCreatives) return [];
      return this.activeCreatives
        .map((creative) => creative.creativeTemplateId);
    },
    canTemplateGroupBeChanged() {
      return !this.GET_IS_CAMPAIGN_READONLY;
    },
  },
  methods: {
    ...mapActions('templates', [
      templatesTypes.FETCH_TEMPLATE_GROUPS,
      templatesTypes.FETCH_TEMPLATES_IN_GROUP_ID,
    ]),
    ...mapMutations('templates', [
      templatesTypes.SET_SELECTED_TEMPLATES,
      templatesTypes.SET_SELECTED_GROUP,
    ]),
    clearSelectedTemplates() {
      this.SET_SELECTED_TEMPLATES([]);
    },
    updateCreativeTemplateGroup(group) {
      if (group) {
        this.selectedTemplateGroup = group;
        this.getTemplatesByGroupId(group.id);
        this.selectedGroupId = group.id;
        this.SET_SELECTED_GROUP(group);
      }
    },
    getTemplatesByGroupId(id) {
      this.FETCH_TEMPLATES_IN_GROUP_ID(id)
        .then((templates) => {
          const templateList = [...templates];
          const allTemplatesSelected = this.campaign.templateGroupId !== id;
          templateList.forEach((template) => {
            template.selected = allTemplatesSelected || this.activeTemplateIds.includes(template.id);
          });
          this.templateList = templateList;
          this.$emit('updateGroup', {
            ...this.selectedTemplateGroup,
            templates: templateList,
          });
          if (!this.isModalView) {
            this.$refs['template-group-templates'].setTemplatesSelected(templateList);
          }
        });
    },
    updateTemplates(selectedIds) {
      this.templateList.forEach((template) => {
        template.selected = selectedIds.includes(template.id);
      });
      this.$emit('updateTemplatesInGroup', this.templateList);
    },
  },
  async created() {
    this.availableTemplateGroups = await this.FETCH_TEMPLATE_GROUPS();
    const selectedTemplateGroup = this.availableTemplateGroups
      .filter((group) => group.id === this.campaign.templateGroupId).pop() || null;
    if (selectedTemplateGroup) {
      this.updateCreativeTemplateGroup(selectedTemplateGroup);
    }
  },
};
</script>
<style scoped lang="scss">
</style>
